import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "LeadTCLPChainOfCustody/";

const getLeadTCLPChainOfCustodyById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetLeadTCLPChainOfCustodyById?jobFormId=' + id, constants.REQUIRE_INTERCEPTORS);

const start = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'Start', model, constants.REQUIRE_INTERCEPTORS);

const save = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'Save', model, constants.REQUIRE_INTERCEPTORS);

const generateLeadTCLPChainOfCustody = async (leadTCLPDatSheetId) => await axiosInstance.post(ENDPOINTORIGIN + 'GenerateLeadTCLPChainOfCustody?leadTCLPDatSheetId=' + leadTCLPDatSheetId, {}, constants.REQUIRE_INTERCEPTORS);

const saveLineItemDescription = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveLineItemDescription', model, constants.REQUIRE_INTERCEPTORS);

const discardCOC = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DiscardCOC?cocId=' + id, constants.REQUIRE_INTERCEPTORS);

const getReportPdf = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetReportPdf?id=' + id, constants.REQUIRE_INTERCEPTORS);


export {
    getLeadTCLPChainOfCustodyById,
    start,
    save,
    saveLineItemDescription,
    generateLeadTCLPChainOfCustody,
    getReportPdf,
    discardCOC
}